import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Typography, Divider } from '@material-ui/core';
import { UIComponent, Cluster, combineEvent, mapClusterKey } from './Base';
import { getHelpIcon, parseHelp } from './Help';
import { Request, Notification, Util } from '../common';
import {Alert} from 'reactstrap';
import { getSizeClassName } from './Layout';
import { HelpLink } from './Button';

function getValue(data,n,array){
    if(array){
        for(let i=0;i<data.length;i++){
            let {field,value} = data[i];
            if(field===n) return value;
        }
    }else{
        for(let e in data){
            if(e.toLocaleLowerCase() === n.toLocaleLowerCase()) return data[e];
        }
    }
}

function ignoreForm(p){
    if(p.ignoreForm===true) return true;
    if(Util.type(p.ignoreForm)==="function") return p.ignoreForm();
    if(p.props.ignoreForm) return true;
    return false;
}

export default class Form extends UIComponent {
   
    constructor(props) {
        super(props);
        this.state={
            ...this.state
        }

        this.submitMaster = mapClusterKey(this.props.submitMaster);
    }

    getInputs(){
        return Cluster.getSlaves(this.submitMaster);
    }

    getInput(n) {
        n = n.toLowerCase();
        let inputs = this.getInputs();
        return Util.first(inputs,(e,i)=> {
            return e.field().toLowerCase() == n;
        });
    }

    get(n) {
        let my =this;
        let { array } = this.props;
        let inputs = this.getInputs();
        if (n) {
            let l = Util.type(n) == "array" ? n : n.split(',');
            let v = array ? [] : {};
            inputs.forEach((e)=> {
                if (l.indexOf(e.field()) == -1) return;
                my.fillValues(v, e);
            });
            return v;
        }
        else {
            let v = array ? [] : {};
            inputs.forEach((e)=> {
                my.fillValues(v, e);
            });
            return v;
        }
    }

    all(){ //获取所有值，不论是否提交
        var my =this;
        let inputs = this.getInputs();
        var v = {};
        inputs.forEach((e)=> {
            my.exec(e, "get", function (p) {
                if (ignoreForm(p)) return; //忽略form，那么不参表单行为
                var pv = p.get();
                v[p.field()] = pv;
            });
        });
        return v;
    }

    fillValues(v,e) {
        let my =this;
        let { array } = this.props;
        this.exec(e, "get", function (p) {
            if (ignoreForm(p)) return; //忽略form，那么不参表单行为
            let pv = p.get();
            if (pv === null) return; //如果返回的值显示指明了为null，那么不提交该值
            if (my.equalsRecord(p, pv)) return; //如果值等于记录中的数据，那么不提交，这表示值没有改变过，不用提交修改
            if(array)
                v.push({field:p.field(),value:pv});
            else
                v[p.field()] = pv;
            if(p.onFormGet) p.onFormGet(pv);
        });
    }

    exec(p, n, f) { //验证组件p是否实现了方法n,如果实现了，则执行函数f
        if (p[n]) { f(p); return }
    }


    _recordData = null;
    equalsRecord(p, v) {
        if (!this.props.record) return false;
        if (!this._recordData) return false;
        if (p.props.ignoreRecord) return; //显示指定了忽略记录的功能，那么就不需要对比
        let n = p.field();
        let rvStr = this._recordData[n.toLowerCase()];
        return JSON.stringify(v) === rvStr;
    }

    setRecord(n, v) {
        if (!this._recordData) this._recordData = {};
        this._recordData[n.toLowerCase()] = JSON.stringify(v); //为了防止值是对象，受到组件使用影响而改变，在这里提前序列化
    }

    removeRecord(n){
        if (!this._recordData) return;
        delete this._recordData[n.toLowerCase()];
    }

    updateRecord = function () {//更新记录值
        let my =this;
        let inputs = this.getInputs();
        inputs.forEach((e) => {
            my.exec(e, "get", function (p) {
                my.setRecord(p.field(), p.get());
            });
        });
    }

    change(data, p) {//改变数据
        p=p||{};
        let {validate,record} = p;  //validate：是否验证，record:改变的数据，是否被记录在表单里
        let my = this; //change方法不重置所有数据，针对性的改数据
        let {array} = this.props;
        if(array){
            data.forEach(({field,value}) => {
                let e = field;
                let p = my.getInput(e);
                if (p) {
                    p.set(value, validate);
                    if (record)
                        my.setRecord(e, p.get());//为了保证数据一致，我们获取一次值
                }
            });
        }else{
            for (let e in data) {
                let p = my.getInput(e);
                if (p) {
                    p.set(data[e], validate);
                    if (record)
                        my.setRecord(e, p.get());//为了保证数据一致，我们获取一次值
                }
            }
        }
    }

    set(data, b) {//接收数据,b:是否验证;//change方法是后来补充的方法，更加灵活，可以配置更多参数
        let {record} = this.props;
        this.change(data,{validate:b,record});
    }

    reset() {
        this.clearError();
        let inputs = this.getInputs();
        let my = this;
        inputs.forEach((e) => {
            my.exec(e, "reset", function (p) {
                p.reset();
            });
        });
        this._recordData = null;
    }

    accept(data, b) { //接受数据，该方法会在数据不同时，触发组件事件
        //只对为空的数据重置，而对有值的数据set,这样避免多于的change,导致死循环
        let inputs = this.getInputs();
        let {record,array} = this.props;
        let my = this;
        inputs.forEach((p)=> {
            let n=p.field();
            let nv=getValue(data,n,array);
            let ov=p.get();

            if(nv===ov || Util.equals(nv,ov)) return;

            if(Util.invalid(nv)){ //无效数据就重置
                p.reset();
                my.removeRecord(n);
            }
            else {
                p.handleChange(nv);
                if (record)
                    my.setRecord(n, p.get());//为了保证数据一致，我们获取一次值
            }
                
        });
    }

    disable(b) {
        // var c = getCore(this);
        // if (b) c.prop("disabled", "disabled");
        // else c.removeAttr("disabled");
    }

    help(v) {
        // _help(this, v);
    }

    ignore(b) { //忽略项，这个方法会将组件隐藏，并且不参与form行为
        // var o = this, oj = this.getJquery();
        // if (b) {
        //     o.ignoreForm = true;
        //     oj.hide();
        // } else {
        //     o.ignoreForm = false;
        //     oj.show();
        // }
    }

    validate(data){
        let {array} = this.props;
        let inputs = Cluster.getSlaves(this.submitMaster);
        let errors=[];
        if(!data) {
            //验证内部组件的值
            inputs.forEach((p)=>{
                if(p.validate){
                    let e = p.validate();
                    if(e) errors.push(e);
                }
            });
        }else{ //验证传递来的值
            inputs.forEach((p)=>{
                if(p.validate){
                    let n = p.field();
                    let v = getValue(data,n,array);
                    let e = p.validate(v);
                    if(e) errors.push(e);
                }
            });
        }
        
        return errors;
    }

    resetValidate(){
        let inputs = Cluster.getSlaves(this.submitMaster);
        inputs.forEach((p)=>{
            if(p.resetValidate){
                p.resetValidate();
            }
        });
    }

    check(data){  //可以传递指定的data，来验证数据是否合法，2020.4.12号新增机制，主要是为了paper
        let errors = this.validate(data);
        //自定义验证
        let {validate} = this.props;
        if(validate){
            let es = validate();
            if(es){
                if(Util.type(es) === "array"){
                    errors = errors.concat(es);
                }
                else{
                    errors.push(es);
                }
            }
        }

        this.setState({errors});
        if(errors.length > 0) {
            if(this.props.notice)
                Notification.error(errors);
            return false;
        }
        return true;
    }

    submit(p){
        if(!this.check()) return;

        let {array} = this.props;

        let data = array? [...this.get(),...p.data] :{...this.get(),...p.data};
        if(p.process) {
            data = p.process(data);
            delete p.process;
        }

        p.success=combineEvent(p.success,()=>{
            let {record} = this.props; //记录模式下，提交后，更新记录，方式连续提交，数据重复提交的问题
            if(record) this.updateRecord();
        });

        Request({
            ...p,
            data
        });
    }

    componentWillMount(){
        super.componentWillMount();
        if(this.submitMaster) this.master={"submit":this.submitMaster};
        Cluster.openMaster(this);
    }

    clearError(){
        this.setState({errors:null});
    }

    renderError(){
        if(this.props.alert===false) return;
        let {errors}=this.state;
        if(!errors || errors.length==0) return;

        return (<div className="col-12">
            <Alert className="alert-addon-card bg-danger text-white shadow-lg mb-4 m-sm-0">
                <span className="icon-addon alert-addon">
                    <i className="zmdi zmdi-info zmdi-hc-fw zmdi-hc-lg"/>
                </span>
                <span className="d-inline-block" style={{fontSize:"1rem"}}>{errors.join("；")}</span>
            </Alert>
        </div>)
    }

    componentDidMount(){
        super.componentDidMount();
        let {data} = this.props;
        if(data) this.accept(data);
    }

    render() {
        let {className} = this.props;
        return (
            <div className={`row c-form ${className}`}>
                <input type="text" style={{display:"none"}} />  {/* 防止只有一个输入组件时回车会自动触发页面刷新 */}
                {this.renderError()}
                {this.props.children}
            </div>
        )
    }
  }
  
  Form.defaultProps = {
    className:'',
    notice:true
  }


 Form.modalClassName="c-mx-vsm-0 my-4 py-2";
 Form.modalSectionClassName="c-mx-vsm-0 my-0 py-0";
 Form.portalClassName="my-4 mx-0";
 Form.portalSectionClassName="my-4 mx-2 c-form-portal";

export class FormSection extends React.Component {
   
    constructor(props) {
        super(props);
    }

    render() {
        let {size,title,offset,className,help} = this.props;
        help = parseHelp(help);
        return (
            <div className={`col-md-${size} col-12 pl-0 pr-0 mt-4 mb-4 c-text-s2 ${offset?'':'c-pl-15px'} m-text-dark-50 c-form-section ${className}`}>
                {help.url?<div className="d-flex flex-row justify-content-start align-items-center">{title}<HelpLink className="ml-1" href={help.url} /></div>:title}
                {help.message?<p className="c-text-s1 m-text-muted mb-0">{help.message}</p>:null}
            </div>
        )
    }
}

FormSection.defaultProps = {
    size:12,
    offset:true,
    className:''
}

FormSection.modalClassName="px-3 c-mb-4d5";

export class FormGroup extends React.Component {
   
    constructor(props) {
        super(props);
    }

    render() {
        let {size,title,className,help} = this.props;
        help = parseHelp(help);
        return (
            <div className={`col-md-${size} col-12 mt-0 mb-4 c-text-s1d5 m-text-dark-50 c-form-group ${className}`}>
                {help.url?<div className="d-flex flex-row justify-content-start align-items-center">{title}<HelpLink className="ml-1" href={help.url} /></div>:title}
                {help.message?<p className="c-text-s0 m-text-muted mb-0">{help.message}</p>:null}
            </div>
        )
    }
}

FormGroup.defaultProps = {
    size:12,
    className:''
}

// FormSection.modalClassName="px-3 c-mb-0";

export class FormCell extends React.Component {
   
    constructor(props) {
        super(props);
    }

    render() {
        let {size,className} = this.props;
        return (
            <div className={`${getSizeClassName(size)} ${className||''}`}>{this.props.children}</div>
        )
    }
}

FormCell.defaultProps = {
    size:12
}

FormCell.repeaterInputClassName="c-my-3";

export class FormAction extends React.Component {
   
    constructor(props) {
        super(props);
    }

    render() {
        let {align,direction,children,className,line} = this.props;
        let alignClassName = '';
        if(align == 'auto'){
            //大屏幕下左对齐按钮
            //小屏幕居中对齐
            alignClassName="justify-content-center justify-content-sm-start";
        }
        else{
            let t = align=="left"?"start":(align=="right"?"end":"center");
            alignClassName=`justify-content-${t}`;
        }

        let directionClassName=direction=='auto'?'flex-column flex-sm-row':`flex-${direction}`;
        
        return (
            <div className={`col-12 c-form-action ${className}`}>
                {line?<Divider className="my-4" />:null}
                <div className={`d-flex ${directionClassName} ${alignClassName} align-items-center`}>
                    {children}
                </div>
            </div>
        )
    }
}

FormAction.modalFirstButtonClassName="c-w-vsm-100 c-vsm-mh2d5";
FormAction.modalButtonClassName="c-w-vsm-100 mt-3 mt-sm-0 ml-sm-2 c-vsm-mh2d5";

FormAction.portalClassName="c-mt-1 c-mb-3";

FormAction.defaultProps = {
    align:"auto",
    className:'',
    line:false,
    direction:'auto'
}
